import { render, staticRenderFns } from "./TreeMenuDesktop.vue?vue&type=template&id=a318b446"
import script from "./TreeMenuDesktop.vue?vue&type=script&lang=js"
export * from "./TreeMenuDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports